import { render, staticRenderFns } from "./SignupQr.vue?vue&type=template&id=bf990410&scoped=true&"
import script from "./SignupQr.vue?vue&type=script&lang=ts&"
export * from "./SignupQr.vue?vue&type=script&lang=ts&"
import style0 from "./SignupQr.vue?vue&type=style&index=0&id=bf990410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf990410",
  null
  
)

export default component.exports